import { useEffect, useState } from 'react'

import { useFloorPlan } from '../../hooks/useFloorPlan'

import {
  useFloorsFacilityCheckpointsQuery,
  useUpdateTourPlanMutation,
} from '@/graphql/generated/hooks'
import { UpdateTourPlanInput } from '@/graphql/generated/schemas'

import { CheckpointIProps } from '../../types/types'
import { updateCheckPointIds } from '../utils/utils'

export const useEditTourPlan = (
  facilityId: string,
  checkedpoints: CheckpointIProps[]
) => {
  const [checkedIds, setCheckedIds] = useState<string[]>([])
  const { data } = useFloorsFacilityCheckpointsQuery({
    fetchPolicy: 'network-only',
    variables: {
      id: facilityId,
    },
    skip: facilityId === undefined,
  })
  const { setHighlightedDeviceIds } = useFloorPlan()
  const [updateTourPlan, { loading: isUpdateLoading }] =
    useUpdateTourPlanMutation()
  const update = async (input: UpdateTourPlanInput) => {
    const { data } = await updateTourPlan({
      variables: { input },
      refetchQueries: ['facilityTourPlans'],
    })
    return data
  }
  const handleChecked = (id: string) => {
    const ids = updateCheckPointIds(checkedIds, id)
    setHighlightedDeviceIds(ids)
    setCheckedIds(ids)
  }

  useEffect(() => {
    if (data) {
      setCheckedIds(checkedpoints?.map((c) => c.id))
    }
  }, [data])

  const orginalCheckedIds = checkedpoints?.map((c) => c.id)

  return {
    floorData: data,
    checkedIds,
    orginalCheckedIds,
    update,
    handleChecked,
    isUpdateLoading,
  }
}
